import(/* webpackMode: "eager", webpackExports: ["BattleHistoryScreen"] */ "/app/apps/landing-app/src/screens/BattleHistoryScreen/index.ts");
